import React from "react";
import aboutImg from "../assets/images/about/22.jpg";
import about5 from "../assets/images/about/about-5.jpeg";
import about1 from "../assets/images/about/about-1.jpeg";
import about2 from "../assets/images/ads.mp4";
import about6 from "../assets/images/about/about-6.jpg";

export default function About() {
  return (
    <div
      className="rts-about-area rts-section-gapBottom position-relative"
      id="about"
    >
      
      <div className="container">
        <div className="row align-items-center">

           <h2 style={{ textAlign: "center", marginBottom: "100px" , marginTop: "0px" , textDecoration: "underline" }}>About Us</h2>
          {/* Left Content */}
          <div className="col-lg-6">
            <div className="solari-about-left-content">
              <div className="title-area-left mt">
                
                <h2 className="title">
                 Flight Tickets , Hotel Booking , Visa Processing , <br /> Travel Insurance.
                </h2>
              </div>
              <div className="content-inner">
                <p className="disc">
                 Our tour packages are customized to make your holidays a memorable celebration. We plan the tours in a way that each destination gets its due share of your valuable time.

We specialize in arranging exclusive tours covering the various destinations and our specially designed tour and travel packages are arranged in such a way that you are able to enjoy each and every exotic location.
                </p>

                {/* Images inside left content */}
            
                {/* Call Button */}
                <div className="solari-about-button-area mt--40">
                  <div className="call-button">
                    <i className="fa-solid fa-phone"></i>
                    <div className="info">
                      <span>Call Us 24/7</span>
                      <a href="tel:+919842421862">
                        <h6 className="title">+91 9894148948</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Images */}
          <div className="col-lg-6 mt_md--50 mt_sm--40">
            <div className="thumbnail-solari-about">
              <video
            src={about2}
            autoPlay
            loop
            muted
            playsInline
            controls
            style={{ width: "50%", borderRadius: "10px" }}
          />
              <div className="experiencea-area images">
                <h3 className="title">15+</h3>
                <p>Years Experience</p>
              </div>
            </div>

         
          </div>
        </div>
      </div>
    </div>
  );
}
